import { render, staticRenderFns } from "./BeneficiaryCard.vue?vue&type=template&id=4f878b14&scoped=true&"
import script from "./BeneficiaryCard.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryCard.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryCard.vue?vue&type=style&index=0&id=4f878b14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f878b14",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CSwitch: require('@chakra-ui/vue').CSwitch, CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox})
